import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export default function InformNewItemRecipe({ close }) {
    return (
        <Dialog open onClose={close} maxWidth="xs" fullWidth>
            <DialogTitle>Recipe needed</DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary">
                    Some new items still need recipes before COGs and stock deduction can work correctly.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={close}>Got it</Button>
            </DialogActions>
        </Dialog>
    );
}
